import { INITIAL_CREATE_MISSION_DATA } from 'components/SlideOver/slideOverUnsavedChanges';

// A prospect or a lost company gets no mission (the api refuses it with
// COMPANY_NOT_CLIENT); no stage means a client, as for the api.
export const isMissionCompany = (stage) => !stage || stage === 'client';

// The mission form's data, on a company already. Its name and its address are
// those of the form's own list (name_commercial and the `location` id), so that
// list finds nothing to fill in after it.
export const missionDataFor = ({ companyId, companyName, idLocation }) => ({
  ...INITIAL_CREATE_MISSION_DATA,
  company: String(companyId),
  companyName: companyName || '',
  idLocation: idLocation ?? null,
});
